import React from "react";
import { Modal, modalStyles } from '@futures-platform/ui'
import { requestTranslation } from '@futures-platform/i18n'

const ConfirmationModal = ({
  regeneratePublicLink,
  confirmationModal,
  confirmationModalClose,
}) => {
  return (
    <Modal
      isOpen={confirmationModal}
      contentLabel="radar-modal"
      ariaHideApp={false}
      style={{ content: { ...modalStyles.content, padding: '50px 0' }, overlay: { ...modalStyles.overlay, zIndex: 11111 } }}
      onRequestClose={confirmationModalClose}
    >
      <div className="confirmation-modal-content" style={{
        paddingBottom: '1.875rem',
        paddingTop: '1.875rem'
      }}>
        <h3 className="confirmation-modal-title">
          {requestTranslation("sharePublicLinkConfirmation")}
        </h3>
        <p style={{textAlign: 'center'}}>{requestTranslation("sharePublicLinkConfirmationNote")}</p>
        <div className="confirmation-modal-actions">
          <button
            onClick={confirmationModalClose}
            className="btn btn-lg btn-plain-gray"
          >
            {requestTranslation("cancel").toUpperCase()}
          </button>
          <button
            className="btn btn-lg btn-primary"
            onClick={regeneratePublicLink}
          >
            {requestTranslation("regeneratePublicLink").toUpperCase()}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
